import React, { useContext } from 'react';
import AdhesionAdUnit from '../AdUnit/Adhesion/Adhesion';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { DEVPAGE_ADHESION_REAL_ESTATE_ID } from '../constants';

export interface Props {}

const DevpageAdhesionPlacement: React.FC<Props> = () => {
  const { isLoggedIn } = useContext(SessionContext);
  const isMobile = useContext(MobileContext);

  // User
  if (isLoggedIn || isMobile) {
    return null;
  }

  // Anon
  return <AdhesionAdUnit realEstateId={DEVPAGE_ADHESION_REAL_ESTATE_ID} />;
};
DevpageAdhesionPlacement.displayName = 'DevpageAdhesionPlacement';

export default DevpageAdhesionPlacement;
